/** @jsxImportSource @emotion/react */
import { lazy } from 'react'
import manifest from '../public/manifest.json'

export const APP_NAME = manifest.name
export const PROJECT_NAME = manifest.project_name

// HomePage owns its full-screen layout and header, so hide the baseline chrome.
export const APP_ROUTES = [
  {
    path: '/',
    component: lazy(() => import('@app-src/pages/HomePage')),
    title: APP_NAME,
    hideChrome: true
  }
]

export default APP_ROUTES
